import styled from "styled-components/macro";

import { useFamilyRegistrationContext } from "Signups/FamilyRegistration/FamilyRegistrationContext";
import { motion } from "framer-motion";

import { FnrScreen } from "UI/FnrScreens";

import ClosingMessage from "./Settings/ClosingMessage";
import CompletionAdminNotification from "./Settings/CompletionAdminNotification/CompletionAdminNotification";
import CompletionNote from "./Settings/CompletionNote";
import FinishedActions from "./Settings/FinishedActions";

export default function FinishingUpPanel() {
  const {
    state: { selectedPanel },
  } = useFamilyRegistrationContext();

  return (
    <FnrScreen show={selectedPanel === "finishing-up"} side="right">
      <Stack>
        <ClosingMessage />
        <FinishedActions />
        <CompletionNote />
        <CompletionAdminNotification />
      </Stack>
    </FnrScreen>
  );
}

const Stack = styled.div`
  > * + * {
    margin-top: 48px;
  }
`;
